import ClassPack from "./ClassPack";

export default ClassPack;
